"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CohortNotFoundError = exports.ConflictingRedemptionError = exports.RedemptionNotFoundError = exports.ConflictingPromoCodeError = exports.PromotionNotRedeemableError = exports.PromotionNotFoundError = exports.ServerError = void 0;
class ServerError extends Error {
    constructor(message, data) {
        super(`${message}: ${JSON.stringify(data)}`);
        this.name = this.constructor.name;
        this.data = data;
    }
}
exports.ServerError = ServerError;
class PromotionNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.PromotionNotFoundError = PromotionNotFoundError;
class PromotionNotRedeemableError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.PromotionNotRedeemableError = PromotionNotRedeemableError;
class ConflictingPromoCodeError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.ConflictingPromoCodeError = ConflictingPromoCodeError;
class RedemptionNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.RedemptionNotFoundError = RedemptionNotFoundError;
class ConflictingRedemptionError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.ConflictingRedemptionError = ConflictingRedemptionError;
class CohortNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.CohortNotFoundError = CohortNotFoundError;
//# sourceMappingURL=errors.js.map